import React from 'react'
import { setModal } from '../../redux/modalSlice'
import { useDispatch } from 'react-redux'
import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function HTMLViewer(props) {
  const { title, text, width, column_name, record, module_code_key } = props
  const dispatch = useDispatch()

  const openModal = (type) => {
    dispatch(
      setModal({ title: title, content: text, type: type, options: { record: record, module_code_key: module_code_key, column_name: column_name } })
    )
  }
  return (
    <>
      <span>{text.substring(0, Math.round(width / 8.3))}</span>
      <button
        data-hover="View All"
        className="button is-link ml-1"
        onClick={() => openModal('html_view')}
        style={{
          height: '1.5rem'
        }}
      >
        <FontAwesomeIcon icon={faEye} />
      </button>
        {!(module_code_key === 'loan_agreement' && record.is_active === 1) ? (
          <button
            data-hover="Edit"
            className="button is-info ml-1"
            onClick={() => {
                if (module_code_key === 'template') {
                    openModal('html_edit_placeholder')
                } else {
                    openModal('html_edit')
                }
            }}
            style={{
                height: '1.5rem'
            }}
          >
          <FontAwesomeIcon icon={faEdit} />
        </button>
          ) : ''}
        </>
  )
}
